import { bytesToNDigits } from '@mail/cross-sizes-utils';
import {
    Icon16ArrowUturnLeftOutline,
    Icon16Block,
    Icon16ChevronOutline,
    Icon16CopyOutline,
    Icon16Stars,
    Icon16UploadOutline,
    Icon20Hearts2Outline,
    Icon24SmileAddOutline,
} from '@vkontakte/icons';
import { ReactComponent as IconUnlimitedAutoupload } from 'img/icons/unlimited-autoupload-16.svg';
import React from 'react';
import { multiTariffHighlightMobile } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import { paidUploadLimit } from 'reactApp/appHelpers/featuresHelpers/features/paidUploadLimit';
import { type FeatureItem, FeatureIDs } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/Features.types';
import { CheckOutlineIcon } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/icons/CheckOutline';
import { NotifyOutlineIcon } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/icons/NotifyOutline';
import { PrettyAddressIcon } from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/Features/icons/PrettyAddress';

export const unlimitedAutouploadItem: FeatureItem = {
    id: FeatureIDs.unlim,
    text: multiTariffHighlightMobile ? 'Безлимит для галереи с телефона' : 'Безлимит для фото с телефона',
    type: 'highlighted',
    iconBefore: <IconUnlimitedAutoupload />,
    iconAfter: <Icon16ChevronOutline />,
};

export const noadsItem: FeatureItem = {
    id: FeatureIDs.noads,
    text: 'Без рекламы в Почте и Облаке',
    type: 'normal',
    iconBefore: <Icon16Block />,
};

export const familyItem: FeatureItem = {
    id: FeatureIDs.family,
    text: 'Добавление ещё 3 участников',
    type: 'normal',
    iconBefore: <Icon24SmileAddOutline width={16} height={16} />,
};

export const familyAlbumsItem: FeatureItem = {
    id: FeatureIDs.familyAlbums,
    text: 'Семейные папки и альбомы',
    type: 'highlighted',
    iconBefore: <Icon20Hearts2Outline width={16} height={16} />,
};

export const uploadItem: FeatureItem = {
    id: FeatureIDs.upload,
    text: `Загрузка файлов до ${bytesToNDigits(paidUploadLimit, 3).value}`,
    type: 'normal',
    iconBefore: <Icon16UploadOutline />,
};

export const othersItem: FeatureItem = {
    id: FeatureIDs.others,
    text: (
        <>
            И другие <span>возможности</span>
        </>
    ),
    type: 'normal',
    iconBefore: <CheckOutlineIcon />,
};

export const duplicatesItem: FeatureItem = {
    id: FeatureIDs.duplicates,
    text: 'Удаление дубликатов',
    type: 'normal',
    iconBefore: <Icon16CopyOutline />,
};

export const aiLetterSetItem: FeatureItem = {
    text: 'Генерация и стиль писем',
    id: FeatureIDs.aiLetterSet,
    type: 'normal',
    iconBefore: <Icon16CopyOutline />,
};

export const aiLetterSummaryItem: FeatureItem = {
    text: 'Краткий пересказ писем',
    id: FeatureIDs.aiLetterSummary,
    type: 'highlighted',
    iconBefore: <Icon16Stars />,
};

export const notificationItem: FeatureItem = {
    text: 'Уведомление о прочтении',
    id: FeatureIDs.notification,
    type: 'normal',
    iconBefore: <NotifyOutlineIcon />,
};

export const cancelSendItem: FeatureItem = {
    text: 'Отмена отправки писем',
    id: FeatureIDs.cancel,
    type: 'normal',
    iconBefore: <Icon16ArrowUturnLeftOutline />,
};

export const prettyAddressItem: FeatureItem = {
    text: 'Красивый адрес',
    id: FeatureIDs.prettyAddress,
    type: 'normal',
    iconBefore: <PrettyAddressIcon />,
};
